import type { ChangeEvent } from 'react';

import useDispatch from 'shared/hooks/useDispatch';
import useSelector from 'shared/hooks/useSelector';
import Search from 'shared/components/Search';

import { cooperativeCommonCasesSlice } from '../../models';
import { selectSearchTerm } from '../../models/selectors';

const SearchBar = () => {
  const dispatch = useDispatch();

  const searchTerm = useSelector(selectSearchTerm);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(
      cooperativeCommonCasesSlice.actions.setSearchTerm(event.target.value)
    );
  };

  return (
    <Search
      debounce
      placeholder="Hae"
      value={searchTerm}
      onChange={handleChange}
    />
  );
};

export default SearchBar;
